import { AccessCircles } from './rules/AccessCircles.svelte';
import { AccessCirclesBreakdown } from './rules/AccessCirclesBreakdown';
import { AccessCirclesPowerUp } from './rules/AccessCirclesPowerUp';
import { AccessGnosisPayOnboarding } from './rules/AccessGnosisPayOnboarding';
import { AccessOnboard } from './rules/AccessOnboard';
import { RequireActiveGnosisPayAccount } from './rules/RequireActiveGnosisPayAccount';
import { RequireDomainMigration } from './rules/RequireDomainMigration';
import { RequireGnosisPayTokenForSubpages } from './rules/RequireGnosisPayTokenForSubpages';
import { RequirePayAddress } from './rules/RequirePayAddress';
import { RequireUsername } from './rules/RequireUsername';
import type { GuardNode } from './utils/guardNode';

export const GUARDS: GuardNode = {
  guards: [RequireDomainMigration, RequireUsername],
  children: {
    'gnosis-pay': {
      guards: [AccessGnosisPayOnboarding],
    },
    circles: {
      guards: [AccessCircles],
      children: {
        'power-up': {
          guards: [AccessCirclesPowerUp],
        },
        breakdown: {
          guards: [AccessCirclesBreakdown],
        },
        onboard: {
          guards: [AccessOnboard],
        },
      },
    },
    onboard: {
      guards: [AccessOnboard],
    },
    card: {
      guards: [RequireGnosisPayTokenForSubpages, RequirePayAddress, RequireActiveGnosisPayAccount],
    },
  },
};
